/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { interpolate, InterpolationData } from '@common';
import { TranslationDictionaryMapping } from '../../models/translation-dictionary/translation-dictionary-mapping.type';
import { TranslationDictionary } from '../../models/translation-dictionary/translation-dictionary.type';
import { TRANSLATION_DICTIONARY_MAPPING } from '../../tokens/translation-dictionary-mapping.token';
import { TranslationDictionaryService } from '../translation-dictionary/translation-dictionary.service';

@Injectable({ providedIn: 'root' })
export class TranslateService<
  T extends TranslationDictionary = TranslationDictionary,
> {
  private readonly translationDictionaryMapping = inject<
    TranslationDictionaryMapping<T>[]
  >(TRANSLATION_DICTIONARY_MAPPING);
  private readonly translationDictionaryService = inject<
    TranslationDictionaryService<T>
  >(TranslationDictionaryService);

  constructor() {
    this.translationDictionaryService.registerTranslationDictionaryMapping(
      ...this.translationDictionaryMapping,
    );
  }

  translate<K extends keyof T>(
    translationId: K,
    interpolationData?: InterpolationData,
  ): string | any {
    const translationDictionary: T | undefined =
      this.translationDictionaryService.translationDictionary;
    const translation = translationDictionary?.[translationId];

    if (!translation) {
      console.error(
        `Translation not found for id: ${translationId.toString()}`,
      );
      return translationId.toString();
    }
    return interpolate(translation, interpolationData);
  }
}
